import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { createFolder } from '../query-api'

interface UseCreateFolderProps {
  onSuccess?: () => void
  onError?: () => void
}

export const useCreateFolder = (props: UseCreateFolderProps) => {
  const { onSuccess, onError } = props
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(createFolder, {
    onSuccess: (_, { parentFolderId }) => {
      queryClient.invalidateQueries(QueryKeys.DmsFolders)
      queryClient.invalidateQueries([QueryKeys.DmsFolderContents, parentFolderId])
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    },
  })

  return {
    createFolder: mutate,
    isLoading,
  }
}
